import api from '../http-common';

const getProfileData = () =>
  api.post('/farmer/profile')

const getSubFarmersData = (data?) =>
  api.post('/farmer/profile/sub-farmers/index', data)

export const FarmerProfileService = {
  getProfileData,
  getSubFarmersData
}